module.exports = __webpack_public_path__ + "banquet/components/InventoryRecordDetail/images/facebook.b89ad7a636a0f81fe6f74da4f3b5992c.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/InventoryRecordDetail/images/facebook.png
// module id = 1667
// module chunks = 1